import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import { UserService } from 'src/app/core/api/user/user.service';
import { AuthenticatedUserService } from 'src/app/core/services/authenticated-user/authenticated-user.service';
import { RegisterService } from 'src/app/core/services/register/register.service';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { DialogModalComponent } from 'src/app/shared/components/molecules/dialog-modal/dialog-modal.component';
import { MatDialogResponse } from 'src/app/shared/models/constants/mat-dialog-response';
import { BusinessResponseDTO } from 'src/app/shared/models/dtos/register-form/business-response-dto/business-response-dto';
import { RoutesKeys } from 'src/app/utils/routes';

@Component({
  templateUrl: './invite-existing.page.html',
})
/**
 * Instatiantes invite existing page template
 */
export class InviteExistingPage implements OnInit {
  private dialogData: any;
  currentBusiness?: BusinessResponseDTO;
  newBusiness?: BusinessResponseDTO;
  private email?: string;

  /**
   * @constructor
   */
  constructor(
    private dialog: MatDialog,
    private translationService: TranslationService,
    private router: Router,
    private userService: UserService,
    private authenticatedUserService: AuthenticatedUserService,
    private registerService: RegisterService
  ) {}

  /**
   * On init
   */
  ngOnInit() {
    this.newBusiness = this.registerService.inviteNewBusiness!;
    this.currentBusiness = this.registerService.inviteCurrentBusiness;
    this.email = this.authenticatedUserService.user?.email;
    if (this.registerService.invitedRepresentativeEmail !== this.email) {
      this.router.navigate([RoutesKeys.HOME]);
      return;
    }

    this.dialogData = {
      content: this.currentBusiness
        ? 'confirm-change-business'
        : 'confirm-accept-invite',
      successButtonText: 'confirm',
      failButtonText: 'cancel',
    };
    this.translationService.translateObject(this.dialogData, {
      content: {
        organization: this.newBusiness.businessName,
      },
    });
  }

  /**
   * Opens accept invitation dialog
   */
  async openAcceptInvitationDialog() {
    const dialogResponse = await this.openDialog();
    if (dialogResponse === MatDialogResponse.SUCCESS) {
      this.acceptInvitation();
    }
  }

  /**
   * Confirms that this representative wants to change his business
   */
  async acceptInvitation() {
    const existingRepresentativeAcceptInvite$ =
      this.userService.existingRepresentativeAcceptInvite(this.email!);

    try {
      const updatedRepresentative = await lastValueFrom(
        existingRepresentativeAcceptInvite$
      );
      this.authenticatedUserService.representative = updatedRepresentative;
      this.router.navigate([RoutesKeys.MEMBERSHIP_SUCCESS]);
    } catch (e) {
      const dialogData = {
        title: 'error-accepting-invitation-dialog-title',
        content: 'error-accepting-invitation-dialog-content',
        successButtonText: 'ok',
      };
      this.translationService.translateObject(dialogData);
      this.dialog.open(DialogModalComponent, {
        data: dialogData,
        autoFocus: false,
      });
    }
  }

  /**
   * Refuses this invitation
   */
  refuseInvite() {
    this.router.navigate([RoutesKeys.INVITE_REFUSE]);
  }

  /**
   * Instantiates a mat dialog and returns the user selected choice
   * @return {Promise<MatDialogResponse>}
   */
  private openDialog(): Promise<MatDialogResponse> {
    // eslint-disable-next-line security/detect-non-literal-fs-filename
    const dialogRef = this.dialog.open(DialogModalComponent, {
      data: this.dialogData,
      autoFocus: false,
    });

    return firstValueFrom<MatDialogResponse>(dialogRef.afterClosed());
  }
}
